:host {
  display: block;
}

  .field-container {
    display: grid;
    grid-template-columns: 10em 1fr 20px;
    align-items: center;
    gap: 1rem;
  }

  .custom-label {
    color: var(--theme-primary-color);
    text-align: right;
    align-items: center;
    font-weight: bold;
    gap: 0.5rem;
  }

  .custom-input {
    padding: 0.2rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
  }
